const d3 = require("d3");


class ResourceGroupVisual {
    constructor(visualiser, resourceComponent, resourceGroup) {
        this.visualiser = visualiser;
        this.resourceComponent = resourceComponent;
        this.resourceGroup = resourceGroup;
        this.defaultColor = this.visualiser.params.colorMapper[this.resourceGroup.id];
        this.setupDefaultValues();
    }

    setupDefaultValues() {
        this.resourceDivs = this.resourceComponent.getPhotoBlockRefs();
        this.resourceBGDivs = this.resourceComponent.getPhotoBackgroundRefs();
    }

    //Handle the css classes for the alternative div
    updateAlternateDiv() {
        if (this.resourceComponent.$refs.alternate == null) {
            return;
        }

        if (this.resourceGroup.alternateName == null && this.resourceGroup.alternateNameToBeTrained == null) {
            this.resourceComponent.$refs.alternate.classList.add('unavailable');
            this.resourceComponent.$refs.alternate.classList.remove('border');
            return;
        }

        this.resourceComponent.alternatename = this.resourceGroup.alternateName || this.resourceGroup.alternateNameToBeTrained;
        var alternateID = this.visualiser.simulator.resourcePool.getResourceGroupFromName(this.resourceComponent.alternatename).id;
        this.resourceComponent.alternatecolor = this.visualiser.params.colorMapper[alternateID];

        if (this.resourceGroup.alternateNameToBeTrained != null) {
            this.resourceComponent.$refs.alternate.classList.remove('unavailable');
            this.resourceComponent.$refs.alternate.classList.add('border');
            return;
        }

        if (this.resourceGroup.alternateName != null) {
            this.resourceComponent.$refs.alternate.classList.remove('unavailable');
            this.resourceComponent.$refs.alternate.classList.remove('border');
            return;
        }
    }

    //Handle the css classes for the photoblocks
    updatePhotoblocks() {

        this.resourceComponent.updateButtons()
        for (var i = 0; i < this.resourceGroup.maxAmount; i++) {
            var currResource = this.resourceGroup.resources[i];
            var currResourceDiv = this.resourceDivs[i];

            if (this.visualiser.simulator.params.isManual)
                currResourceDiv.setAttribute('draggable', true);
            else
                currResourceDiv.setAttribute('draggable', false);


            var currResourceBGDiv = this.resourceBGDivs[i];
            if (currResource.isActive) {
                currResourceDiv.classList.remove('unavailable')
            }
            else {
                currResourceDiv.classList.add('unavailable')
            }

            if (currResource.currentTask == null) {
                currResourceDiv.classList.remove('assignedToTask')
            }
            else {

                currResourceDiv.classList.add('assignedToTask')
            }
            

            var lastMetric = this.visualiser.simulator.performanceTracker.getLatestMetrics();
            //Might show the overloaded icon

            if(this.visualiser.simulator.params.showResourceOverload && lastMetric.load[this.resourceGroup.id] > lastMetric.currWorking[this.resourceGroup.id]){
                this.resourceComponent.getOverloadDivs()[0].style.visibility='visible';
                this.resourceComponent.getOverloadDivs()[1].$el.style.visibility='visible';
            }
            else{
                this.resourceComponent.getOverloadDivs()[0].style.visibility='hidden';
                this.resourceComponent.getOverloadDivs()[1].$el.style.visibility='hidden';
            }

            
            //Add the colour of the current task to the background of each resource
            if (currResource.currentTask == null) {

                currResourceBGDiv.style.backgroundColor = this.defaultColor;
            }
            else {
                currResourceBGDiv.style.backgroundColor = this.visualiser.params.colorMapper[currResource.currentTask.resourceGroupID];
            }

            if (currResource.remHireHours != null) {
                currResourceBGDiv.classList.add("lds-ring-add")
                currResourceDiv.classList.remove('unavailable')
            }
            else {
                currResourceBGDiv.classList.remove("lds-ring-add")
            }

            //Check if the resource is being fired
            if (currResource.remFireHours != null) {
                currResourceBGDiv.classList.add("lds-ring-rem")
                currResourceDiv.classList.remove('unavailable')
            }
            else {
                currResourceBGDiv.classList.remove("lds-ring-rem")
            }
        }
    }
    updateElements(duration) {
        this.updateAlternateDiv();
        this.updatePhotoblocks();
    }
}


module.exports = { ResourceGroupVisual };
